const WC_CODE_TYPE_TO_BWIP_CODE_TYPE = {
    'aztec-code': 'azteccode',
    codabar: 'rationalizedCodabar',
    'code-11': 'code11',
    'code-128': 'code128',
    'code-16K': 'code16k',
    'code-32': 'code32',
    'code-39': 'code39',
    'code-39-full-ASCII': 'code39ext',
    'code-49': 'code49',
    'code-93': 'code93',
    'data-matrix': 'datamatrix',
    'EAN-13': 'ean13',
    'EAN-8': 'ean8',
    'GS1-128': 'gs1-128',
    'GS1-dataBar-expanded': 'databarexpanded',
    'GS1-dataBar-limited': 'databarlimited',
    'GS1-data-matrix': 'gs1datamatrix',
    'GS1-QR': 'gs1qrcode',
    'han-xin': 'hanxin',
    IATA: 'iata2of5', // check
    ISSN: 'issn',
    ITF: 'itf14', // check
    'matrix-2-of-5': 'matrix2of5',
    maxicode: 'maxicode',
    'micro-QR-code': 'microqrcode',
    MSI: 'msi',
    PDF417: 'pdf417',
    'planet-US': 'planet',
    'postal-japan': 'japanpost',
    'postal-UK': 'royalmail',
    'postnet-US': 'postnet',
    'QR-code': 'qrcode',
    'UPC-A': 'upca',
    'UPC-E': 'upce',
} as const satisfies Record<string, string>;

export function wcCodeTypeToBwipCodeType(type: string): string | null {
    if (type in WC_CODE_TYPE_TO_BWIP_CODE_TYPE) {
        return WC_CODE_TYPE_TO_BWIP_CODE_TYPE[type as keyof typeof WC_CODE_TYPE_TO_BWIP_CODE_TYPE];
    }

    return null;
}
